import { Box, Button, Modal, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import axios from '../../../axios/AxiosInterceptors';

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
}

const UploadFileModal = (props) => {

    const [peakFileName, setPeakFileName] = useState('');
    const [peakFile, setPeakFile] = useState();
    const [fileUploadSuccess, setFileUplaodSuccess] = useState(false);
    const [fileUploadError, setFileUplaodError] = useState();

    const fileChosen = (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0], e.target.files[0].name);
        setPeakFileName(e.target.files[0].name);
        setPeakFile(formData);
    }

    const uploadPeakFile = async () => {
        await trackPromise(axios.post("/peak-manager/v1", peakFile).then(response => {
            setFileUplaodSuccess(true);
        }).catch(error => {
            setFileUplaodError(error);
        }));
    }

    const onClose = () => {
        setFileUplaodSuccess(false);
        setFileUplaodError(undefined);
        setPeakFileName('');
        setPeakFile(undefined);
        props.handleModalClose();
    }

    return (
        <React.Fragment>
            <Modal open={props.modalOpen} onClose={() => onClose()}>
                <Box sx={{ ...modalStyle }}>
                    <Typography variant="h5" align="center">Upload Peak File</Typography>
                    {fileUploadSuccess &&
                        <React.Fragment>
                            <Typography variant="h6" align="center" style={{ color: 'green' }}>File uploaded successfully.</Typography>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => onClose()}>OK</Button>
                            </div>
                        </React.Fragment>
                    }
                    {fileUploadError &&
                        <React.Fragment>
                            <Typography variant="h6" align="center" style={{ color: 'red' }}>Failed to upload file.</Typography>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => onClose()}>OK</Button>
                            </div>
                        </React.Fragment>}
                    <label htmlFor="uploadPeakFile">
                        <TextField value={peakFileName} InputProps={{ startAdornment: <Button component="span">Choose File</Button> }} fullWidth mt={3} />
                        <input style={{ display: "none" }} id="uploadPeakFile" name="uploadPeakFile" type="file" onChange={fileChosen} />
                    </label>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={uploadPeakFile} align="center">Upload</Button>
                    </div>
                </Box>
            </Modal>
        </React.Fragment>
    )

}

export default UploadFileModal;